import { createStyles } from '@mantine/core';

export const AVATAR_SIZE = 32;

export const useStyles = createStyles((theme) => ({
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._12,
    padding: `${theme.other.spacing._12}px 0`,
    borderBottom: `1px solid ${theme.colors.gray2[0]}`,

    '&:last-of-type': {
      borderBottom: 'none',
    },
  },
  shareholderLink: {
    color: theme.colors.gray2[6],
    minWidth: 0,

    '@media (hover: hover)': {
      transition: 'opacity 150ms ease-in-out',

      '&:hover': {
        opacity: 0.5,
      },
    },
  },
  identity: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minWidth: 0,
  },
  meta: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._4,
    color: theme.colors.gray2[3],
  },
  makesPicks: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._4,
    color: theme.colors.green[6],
  },
  separator: {
    color: theme.colors.gray2[3],
  },
}));
